import { Component, Input } from '@angular/core';

@Component({
	selector: 'dl-section-header',
	templateUrl: './section-header.component.html',
	styleUrls: ['./section-header.component.scss']
})
export class SectionHeaderComponent {

	@Input() public asOfDate: string;
	@Input() public title: string;
	@Input() public titleDcr: string;
	@Input() public subTitle: string;
	@Input() public subTitleDcr: string;
	@Input() public tooltipText: string;
	@Input() public tooltipDcr: string;
	@Input() public showSectionSeparator: boolean = true;
	@Input() public poweredByDcr: string = 'POWERED_BY_ALADDIN';
	@Input() public poweredByDefaultText: string = 'Powered by Aladdin';

}
